import React from 'react';
import { Button, IconButton, Box, Slide } from '@mui/material';
import {
    QrCodeScanner as QrCodeScannerIcon,
    Close as CloseIcon,
} from '@mui/icons-material';

const QRProductButton = ({ url, onDismiss, sx }) => {
    const handleOpen = () => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Slide direction="up" in={Boolean(url)} mountOnEnter unmountOnExit>
            <Box
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 50,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    ...sx,
                }}
            >
                <Button
                    variant="contained"
                    onClick={handleOpen}
                    startIcon={<QrCodeScannerIcon />}
                    sx={{
                        bgcolor: 'rgba(29,152,231, 0.95)',
                        color: '#fff',
                        fontWeight: 700,
                        letterSpacing: 0.5,
                        px: 2.5,
                        py: 1.25,
                        borderRadius: 999,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.35)',
                        '&:hover': { bgcolor: 'rgba(29,152,231, 1)' },
                    }}
                >
                    VER PRODUCTO
                </Button>
                {onDismiss && (
                    <IconButton
                        size="small"
                        onClick={onDismiss}
                        aria-label="Cerrar"
                        sx={{
                            bgcolor: 'rgba(0,0,0,0.6)',
                            color: '#fff',
                            '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        </Slide>
    );
};

export default QRProductButton;
